import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { AzureConfigurationItem } from "./AzureConfigurationItem"

import type { AzureConfigurationTabProps } from "."
import { isAzureInstallation } from "./AzureConfigurationTab.selector"

export const AzureConfigurationTab = (props: AzureConfigurationTabProps) => {
  const keyPrefix = "integrations.connect.azure."
  const [data, { t }] = useIntegration(props)
  const installations = isAzureInstallation(data?.configuration?.installations)
    ? data?.configuration?.installations
    : []
  const noData = !installations.length

  return (
    <>
      {noData && t(`${keyPrefix}noGroup`)}
      {!noData &&
        installations.map(({ organizationName: name, reposCount, ...rest }) => (
          <AzureConfigurationItem
            key={name}
            keyPrefix={keyPrefix}
            values={{ name, id: name, reposCount, ...rest }}
            {...props}
          />
        ))}
    </>
  )
}
